import { observable } from 'mobx';
import { BaseFilter } from '../..';
import StudentPaymentMethod from './StudentPaymentMethod';

export default class StudentPaymentMethodFilter extends BaseFilter<StudentPaymentMethod> {
    constructor(filter?: Partial<StudentPaymentMethodFilter>) {
        super();
        if (filter) this.update(filter);
    }

    @observable studentId?: string;

    update(changes: Partial<StudentPaymentMethodFilter>) {
        super.update(changes);
    }
}
